module.exports = __webpack_public_path__ + "public/img/logo-yec-new.12a1301a.png";